
import { defineComponent, PropType } from 'vue'

// Radio group with one radio by default
export default defineComponent({
  name: 'BBRadio',
  props: {
    // 0 equals none selected, 1 stands for 1st checkbox etc
    selectedRadio: {
      type: Number,
      default: 0
    },
    radioCount: {
      type: Number,
      default: 1
    },
    disabled: {
      type: Array as PropType<boolean[]>,
      default: () => []
    },
    dark: {
      type: Boolean,
      default: false
    },
    labels: {
      type: Array as PropType<string[]>,
      default: () => []
    }
  }
})
